
export const products = [
  '直轨', '超薄直轨', '内嵌式轨道', '弯轨', '超薄弯轨', '蛇形帘', '窗帘盒挡板',//轨道
  '罗马杆',
  '梦幻帘',
  '成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '蜂巢帘', '日夜帘',//成品帘
  '垂直帘', '蜂巢天窗', '竹草帘',//成品帘
  '磁控百叶',
  // '风琴帘', '折叠门', '内开内倒帘', 'PVC门帘', '哈纳斯帘', '无类型(幔)', '无类型(熨烫)', '宜家轨道', '宜家罗马杆', '壁虎帘', '连体轨道', '麻草帘',
];
export const products2 = [
  '直轨', '超薄直轨', '内嵌式轨道', '弯轨', '超薄弯轨', '蛇形帘', '窗帘盒挡板',//轨道
  '罗马杆', '宜家罗马杆',
  '梦幻帘',
  '磁控百叶',
  '成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '蜂巢帘', '日夜帘',//成品帘
  '垂直帘', '蜂巢天窗', '竹草帘', '风琴帘', '折叠门', '内开内倒帘', 'PVC门帘', '哈纳斯帘', '壁虎帘', '麻草帘',//成品帘
  '无类型(幔)', '无类型(熨烫)', '宜家轨道', '连体轨道',//轨道

];

//轨道类
export const rodrailsTypes = ['直轨', '超薄直轨', '弯轨', '超薄弯轨', '内嵌式轨道', '蛇形帘', '窗帘盒挡板', '无类型(幔)', '无类型(熨烫)', '宜家轨道', '连体轨道',]
//成品帘
export const standardsTypes = ['成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '蜂巢帘',
  '日夜帘', '垂直帘', '蜂巢天窗', '竹草帘', '风琴帘', '折叠门', '内开内倒帘', 'PVC门帘', '哈纳斯帘', '壁虎帘', '麻草帘'];
//安装方式
export const installs = ['顶装', '侧装', '两头装', '内顶装', '内侧装', '内两头装', '外顶装', '外侧装', , '外两头装', '免打孔', '内嵌式安装'];
//窗户类型
export const winType1 = ['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗', '异型窗', '天窗', '门框'];
export const winType2 = ['垂直型', '弧形', '斜边型'];
//安装面
export const wallInstall = ['木板', '混凝土', '瓷砖', '金属', '石膏板', '保温层', '砖墙', '大理石', '全瓷玻化砖']
// 单层滑轮权限
export const singlePulley = ['直轨', '超薄直轨', '弯轨', '超薄弯轨', '内嵌式轨道', '蛇形帘', '梦幻帘'];
export const singlePulley1 = ['直轨', '超薄直轨', '弯轨', '超薄弯轨', '内嵌式轨道'];

//获取安装方式
export const getInstall = (prop1) => {
  let install = [];
  if (['直轨', '超薄直轨', '弯轨', '超薄弯轨', '梦幻帘', '蛇形帘', '窗帘盒挡板', '连体轨道', '无类型(幔)', '无类型(熨烫)', '宜家轨道',].includes(prop1)) {
    install = ['顶装', '侧装', '已安装'];
  } else if (['内嵌式轨道',].includes(prop1)) {
    install = ['顶装', '已安装'];
  } else if (['罗马杆', '宜家罗马杆',].includes(prop1)) {
    install = ['顶装', '侧装', '两头装', '已安装'];
  } else if (['成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '日夜帘', '垂直帘', '蜂巢帘', '竹草帘', '风琴帘', '内开内倒帘',
    '哈纳斯帘', '麻草帘',
  ].includes(prop1)) {
    install = ['内顶装', '内侧装', '内两头装', '外顶装', '外侧装', '外两头装', '内嵌式安装', '免打孔'];
  } else if (['蜂巢天窗', '壁虎帘', '折叠门', 'PVC门帘',].includes(prop1)) {
    install = ['内嵌式安装'];
  } else if (['磁控百叶',].includes(prop1)) {
    install = ['玻璃内框'];
  } else {
    install = [];
  }
  return install;
}
//宽高说明
export const sizeWidth = (plan1, plan2, plan3, plan4) => {
  let widthExplain = [];
  plan2 = plan2.split('|')[0]
  if (plan1 + plan2 === '直轨顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '左石膏线到右石膏线', '轨道成品尺寸', '满盒尺寸', '内框宽度', '窗框两边已各加20厘米', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '轨道成品尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '直轨侧装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '直轨已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸'];
    }
  } else if (plan1 + plan2 === '超薄直轨顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '左石膏线到右石膏线', '轨道成品尺寸', '满盒尺寸', '内框宽度', '窗框两边已各加20厘米', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义',];
    }
  } else if (plan1 + plan2 === '超薄直轨侧装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '轨道成品尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义',];
    }
  } else if (plan1 + plan2 === '超薄直轨已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸'];
    }
  } else if (plan1 + plan2 === '内嵌式轨道顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['内嵌式轨道槽长', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型内嵌式轨道槽长', 'U型内嵌式轨道槽长', '内嵌式轨道槽长', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型内嵌式轨道槽长', 'U型内嵌式轨道槽长', '内嵌式轨道槽长', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['内嵌式轨道槽长', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '内嵌式轨道已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸'];
    }
  } else if (plan1 + plan2 === '弯轨顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '左石膏线到右石膏线', '轨道成品尺寸', '满盒尺寸', '内框宽度', '窗框两边已各加20厘米', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '弯轨侧装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '弯轨已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸'];
    }
  } else if (plan1 + plan2 === '超薄弯轨顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '左石膏线到右石膏线', '轨道成品尺寸', '满盒尺寸', '内框宽度', '窗框两边已各加20厘米', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '超薄弯轨侧装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
    }
  } else if (plan1 + plan2 === '超薄弯轨已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸'];
    }
  } else if (plan1 + plan2 === '罗马杆顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙', '窗帘盒长', '窗户两边已各加30厘米', '罗马杆净杆（只在系统显示该选项）', '罗马杆含头尺寸（只在系统显示该选项）', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['罗马杆净杆尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型满墙', 'U型满墙', 'L型窗帘盒长', 'U型窗帘盒长', '窗户两边已各加30厘米', '罗马杆净杆（只在系统显示该选项）', '罗马杆含头尺寸（只在系统显示该选项）', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['不能做罗马杆'];
    }
  } else if (plan1 + plan2 === '罗马杆侧装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙', '窗户两边已各加30厘米', '罗马杆净杆（只在系统显示该选项）', '罗马杆含头尺寸（只在系统显示该选项）', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['罗马杆净杆尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型满墙', 'U型满墙', '窗户两边已各加30厘米', '罗马杆净杆（只在系统显示该选项）', '罗马杆含头尺寸（只在系统显示该选项）', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['不能做罗马杆'];
    }
  } else if (plan1 + plan2 === '罗马杆两头装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙', '罗马杆净杆（只在系统显示该选项）', '罗马杆含头尺寸（只在系统显示该选项）', '自定义'];
    } else if (['一字型飘窗'].includes(plan3)) {
      widthExplain = ['罗马杆净杆尺寸', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'];
    } else if (['U型飘窗', '左L型飘窗', '右L型飘窗', '左L型窗', '右L型窗', 'U型窗', '异型窗'].includes(plan3)) {
      widthExplain = ['不能做罗马杆'];
    }
  } else if (plan1 + plan2 === '罗马杆已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', '左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['罗马杆净杆', '罗马杆含头尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['不能做罗马杆'];
    }
  } else if (plan1 + plan2 === '梦幻帘顶装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '左石膏线到右石膏线', '轨道成品尺寸', '满盒尺寸', '内框宽度', '窗框两边已各加20厘米', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '轨道成品尺寸', '自定义'];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['不能做梦幻帘'];
    }
  } else if (plan1 + plan2 === '梦幻帘侧装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
      widthExplain = ['满墙尺寸', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
    } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义'
      ];
    } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
      widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['不能做梦幻帘'];
    }
  } else if (plan1 + plan2 === '梦幻帘已安装') {
    if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
      widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
    } else if (['异型窗'].includes(plan3)) {
      widthExplain = ['不能做梦幻帘'];
    }
  } else if (['成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '日夜帘', '垂直帘'].includes(plan1)) {
    if (['内顶装', '内侧装', '内两头装', '免打孔'].includes(plan2)) {
      widthExplain = ['内框尺寸', '成品尺寸', '自定义'];
    } else if (['外顶装', '外侧装', '外两头装'].includes(plan2)) {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗'].includes(plan3)) {
        widthExplain = ['满墙宽度', '窗框两边已各加5厘米', '成品尺寸', '自定义',];
      } else if (['U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型满墙宽度', 'U型满墙宽度', '成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙宽度', '成品尺寸', '自定义',];
      }
    }
  } else if (['蛇形帘', '窗帘盒挡板', '连体轨道'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '左石膏线到右石膏线', '轨道成品尺寸', '满盒尺寸', '内框宽度', '窗框两边已各加20厘米', '自定义'];
      } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '轨道成品尺寸', '自定义'];
      } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
        widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
      }
    } else if (plan2 === '侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['轨道成品尺寸', 'L型飘窗总长', 'U型飘窗总长', '飘窗内满墙尺寸', '飘窗内框内尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗', 'U型窗'].includes(plan3)) {
        widthExplain = ['L型窗2边尺寸', 'L型阳台总长', 'U型窗3边尺寸', 'U型阳台总长', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '框内尺寸', '轨道成品尺寸', '自定义'];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含吊臂长度8厘米）'];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['轨道成品尺寸'];
      }
    }
  } else if (plan1 === '磁控百叶') {
    widthExplain = ['玻璃内框高度', '成品尺寸', '自定义'];
  } else {
    widthExplain = ['自定义'];
  }
  if (!widthExplain[0]) {
    widthExplain = ['自定义'];
  }
  return widthExplain;
};
export const sizeHeight = (plan1, plan2, plan3) => {
  plan2 = plan2.split('|')[0]
  let heightExplain = [];
  if (['直轨', '超薄直轨', '弯轨', '超薄弯轨'].includes(plan1)) {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '窗框顶到地面', '窗框顶到台面', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面 ', '挂钩成品尺寸', '自定义'];
    } else if (plan2 === '已安装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到客户指定位置', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '内嵌式轨道') {
    if (plan2 === '顶装') {
      heightExplain = ['槽顶到地面', '槽顶到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '窗框顶到地面', '窗框顶到台面', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到客户指定位置', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '罗马杆') {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '打孔成品尺寸', '自定义',];
    } else if (['侧装', '两头装'].includes(plan2)) {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面 ', '打孔成品尺寸', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['罗马杆杆上沿到地面', '罗马杆杆上沿到台面', '罗马杆挂环下沿到地面', '罗马杆挂环下沿到台面', '打孔成品尺寸', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '梦幻帘') {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '窗框顶到地面', '窗框顶到台面', '飘窗顶到飘窗台面', '挂珠成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '挂珠成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['挂珠下沿到地面', '挂珠下沿到台面', '挂珠下沿到客户指定位置', '挂珠成品尺寸', '自定义',];
    }
  } else if (['成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '日夜帘', '垂直帘'].includes(plan1)) {
    if (['内顶装', '内两头装', '内侧装', '免打孔'].includes(plan2)) {
      heightExplain = ['内框高度', '成品尺寸', '自定义'];
    } else if (['外顶装', '外两头装', '外侧装'].includes(plan2)) {
      heightExplain = ['盒顶到台面', '房顶到台面', '吊顶到台面', '成品尺寸', '自定义',];
    }
  } else if (['蛇形帘', '窗帘盒挡板', '连体轨道'].includes(plan1)) {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '窗框顶到地面', '窗框顶到台面', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '吊顶到地面', '吊顶到台面', '房顶到地面', '房顶到台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '轨道下沿到地面', '轨道下沿到台面', '轨道下沿到客户指定位置', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '磁控百叶') {
    if (plan2 === '玻璃内框') {
      heightExplain = ['玻璃内框高度', '成品尺寸', '自定义',];
    }
  } else {
    heightExplain = ['自定义'];
  }
  if ((rodrailsTypes.includes(plan1) || standardsTypes.includes(plan1) || plan1 === '梦幻帘') && ['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
    heightExplain.push('飘窗垫高度说明');
  }
  return heightExplain;
}
export const sizeWidth2 = (plan1, plan2, plan3, plan4) => {
  let widthExplain = [];
  plan2 = plan2.split('|')[0]
  if (['直轨', '超薄直轨', '弯轨', '超薄弯轨', '无类型(幔)', '无类型(熨烫)', '宜家轨道', '连体轨道'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满盒尺寸', '满墙尺寸', '内框宽度', '左石膏线到右石膏线', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['满盒尺寸', '满墙尺寸', '内框宽度', '左（）到右（）', '飘窗内满墙宽', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满盒尺寸', 'U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型飘窗左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满盒尺寸', 'L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型窗帘盒长', 'U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型飘窗左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型窗帘盒长', 'L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗帘盒长', '异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义'];
      }
    } else if (plan2 === '侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '左（）到右（）', '轨道成品尺寸', '自定义'];
      } else if (['一字型飘窗'].includes(plan3)) {
        if (plan1 === '弯轨') {
          widthExplain = ['满墙尺寸', '内框宽度', '飘窗内满墙宽', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
        } else {
          widthExplain = ['飘窗内满墙宽', '满墙尺寸', '内框宽度', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
        }
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义'];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义'];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗', '异型窗'].includes(plan3)) {
        widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含滑车臂长8厘米）', '轨道成品尺寸（含滑车臂长8厘米）', '自定义'];
      }
    }
  } else if (['内嵌式轨道'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗'].includes(plan3)) {
        widthExplain = ['内嵌式轨道槽长', '轨道成品尺寸', '左（）到右（）', '自定义',];
      } else if (['U型飘窗', 'U型窗'].includes(plan3)) {
        widthExplain = ['U型内嵌式轨道槽长', '轨道成品尺寸', 'U型飘窗左（）到右（）', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型内嵌式轨道槽长', '轨道成品尺寸', 'L型飘窗左（）到右（）', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型内嵌式轨道槽长', '轨道成品尺寸', '异型窗左（）到右（）', '自定义',];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗', '异型窗'].includes(plan3)) {
        widthExplain = ['轨道成品尺寸', '轨道成品尺寸（不含滑车臂长8厘米）', '轨道成品尺寸（含滑车臂长8厘米）', '自定义'];
      }
    }
  } else if (['罗马杆', '宜家罗马杆'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙', '窗帘盒长', '窗户两边已各加30厘米', '左（）到右（）', '罗马杆净杆（哪里到哪里）', '罗马杆含头尺寸（哪里到哪里）', '自定义', '罗马杆净杆（窗户两边已各加30厘米）',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗内满墙宽', '满墙尺寸', '满盒尺寸', '内框宽度', '窗左（）到右（）', '窗框两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '罗马杆含头尺寸（哪里到哪里）', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型飘窗满盒尺寸', 'U型窗内框尺寸', 'U型窗左（）到右（）', 'U型窗框两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型飘窗满盒尺寸', 'L型窗内框尺寸', 'L型窗左（）到右（）', 'L型窗框两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型满墙尺寸', 'U型窗帘盒长', 'U型阳台总长', 'U型窗内框尺寸', 'U型窗左（）到右（）', 'U型窗两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型满墙尺寸', 'L型窗帘盒长', 'L型阳台总长', 'L型窗内框尺寸', 'L型窗左（）到右（）', 'L型窗两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['不能做罗马杆'];
      }
    } else if (plan2 === '侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙', '左（）到右（）', '窗户两边已各加30厘米', '罗马杆净杆（哪里到哪里）', '罗马杆含头尺寸（哪里到哪里）', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗内满墙宽', '满墙尺寸', '左（）到右（）', '窗框两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '罗马杆含头尺寸（哪里到哪里）', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗左（）到右（）', 'U型窗框两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗左（）到右（）', 'L型窗框两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型满墙尺寸', 'U型阳台总长', 'U型窗左（）到右（）', 'U型窗两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型满墙尺寸', 'L型阳台总长', 'L型窗左（）到右（）', 'L型窗两边已各加20厘米', '罗马杆净杆（哪里到哪里）', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['不能做罗马杆'];
      }
    } else if (plan2 === '两头装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙', '内框尺寸', '罗马杆净杆尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗内满墙尺寸', '飘窗内框内尺寸', '罗马杆净杆尺寸', '自定义',];
      } else if (['U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['不能做罗马杆两头装'];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['不能做罗马杆两头装'];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['罗马杆净杆', '罗马杆含头尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['不能做罗马杆'];
      }
    }
  } else if (['梦幻帘'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满盒尺寸', '满墙尺寸', '左石膏线到右石膏线', '内框宽度', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['满盒尺寸', '满墙尺寸', '内框宽度', '飘窗内满墙宽', '窗左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满盒尺寸', 'U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型窗左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满盒尺寸', 'L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型窗左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型窗帘盒长', 'U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型窗左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型窗帘盒长', 'L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型窗左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗帘盒长', '异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      }
    } else if (plan2 === '侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '飘窗内满墙宽', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型满墙尺寸', 'U型阳台总长', 'U型窗左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型满墙尺寸', 'L型阳台总长', 'L型窗左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸轨道含头成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗', '异型窗'].includes(plan3)) {
        widthExplain = ['轨道含头成品尺寸', '自定义'];
      }
    }

  } else if (['成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '蜂巢帘', '日夜帘', '垂直帘',
    '竹草帘', '风琴帘', '内开内倒帘', '哈纳斯帘', '麻草帘'].includes(plan1)) {
    // '内顶装', '内侧装', '内两头装', '免打孔','外顶装', '外侧装', '外两头装'
    if (['内顶装', '内侧装'].includes(plan2)) {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['内框尺寸', '成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗满墙尺寸', '内框尺寸', '成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型内框尺寸', 'U型飘窗满墙尺寸', '成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型内框尺寸', '成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型内框尺寸', '成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型内框尺寸', '成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗内框尺寸', '成品尺寸', '自定义',];
      }
    } else if (plan2 === '内两头装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗'].includes(plan3)) {
        widthExplain = ['内框尺寸', '满墙尺寸', '成品尺寸', '自定义',];
      }
    } else if (plan2 === '外顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['窗帘盒长', '满墙宽度', '窗框两边已各加5厘米', '左（）到右（）', '成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['窗帘盒长', '飘窗满墙宽度', '窗框两边已各加5厘米', '左（）到右（）', '成品尺寸', '自定义',];
      } else if (['U型飘窗', 'U型窗'].includes(plan3)) {
        widthExplain = ['U型窗帘盒长', 'U型满墙宽度', 'U型窗框两边已各加5厘米', 'U型窗左（）到右（）', '成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型窗帘盒长', 'L型满墙宽度', 'L型窗框两边已各加5厘米', 'L型窗左（）到右（）', '成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙宽度', '成品尺寸', '自定义',];
      }
    } else if (plan2 === '外侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙宽度', '窗框两边已各加5厘米', '左（）到右（）', '成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗满墙宽度', '窗框两边已各加5厘米', '左（）到右（）', '成品尺寸', '自定义',];
      } else if (['U型飘窗', 'U型窗'].includes(plan3)) {
        widthExplain = ['U型满墙宽度', 'U型窗框两边已各加5厘米', 'U型窗左（）到右（）', '成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗', '左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型满墙宽度', 'L型窗框两边已各加5厘米', 'L型窗左（）到右（）', '成品尺寸', '自定义',];
      } else if ([].includes(plan3)) {
        widthExplain = [];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙宽度', '异型窗框两边已各加5厘米', '成品尺寸', '自定义',];
      }
    } else if (plan2 === '外两头装') {
      widthExplain = ['满墙宽度', '左（）到右（）', '成品尺寸', '自定义',];
    } else if (plan2 === '内嵌式安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗'].includes(plan3)) {
        widthExplain = ['玻璃框内尺寸', '内框尺寸', '成品尺寸', '自定义',];
      }
    } else if (plan2 === '免打孔') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗'].includes(plan3)) {
        widthExplain = ['内框尺寸', '成品尺寸', '自定义',];
      }
    }

  } else if (['蛇形帘'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满盒尺寸', '满墙尺寸', '内框宽度', '左石膏线到右石膏线', '内嵌式轨道槽长', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['满盒尺寸', '满墙尺寸', '内框宽度', '内嵌式轨道槽长', '左（）到右（）', '飘窗内满墙宽', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满盒尺寸', 'U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型内嵌式轨道槽长', 'U型飘窗左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满盒尺寸', 'L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型内嵌式轨道槽长', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型窗帘盒长', 'U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型内嵌式轨道槽长', 'U型飘窗左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型窗帘盒长', 'L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型内嵌式轨道槽长', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗帘盒长', '异型窗满墙尺寸', '异型窗框内尺寸', '异型内嵌式轨道槽长', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      }
    } else if (plan2 === '侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '左（）到右（）', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗内满墙宽', '满墙尺寸', '内框宽度', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义',
        ];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗', '一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗', 'U型窗', '左L型窗', '右L型窗', '异型窗'].includes(plan3)) {
        widthExplain = ['轨道成品尺寸', '自定义'];
      }
    }

  } else if (['蜂巢天窗',].includes(plan1)) {
    if (plan2 === '内嵌式安装') {
      // if (['天窗'].includes(plan3)) {
      widthExplain = ['玻璃内框宽度', '内框尺寸', '成品宽度', '自定义',];
      // }
    }
  } else if (['壁虎帘'].includes(plan1)) {
    if (plan2 === '内嵌式安装') {
      // if (['门框'].includes(plan3)) {
      widthExplain = ['内框宽度', '玻璃框内尺寸', '成品宽度', '自定义',];
      // }
    }
  } else if (['折叠门', 'PVC门帘'].includes(plan1)) {
    if (plan2 === '内嵌式安装') {
      // if (['门框'].includes(plan3)) {
      widthExplain = ['内框宽度', '成品宽度', '自定义',];
      // }
    }
  } else if (['磁控百叶'].includes(plan1)) {
    if (['垂直型'].includes(plan3)) {
      widthExplain = ['玻璃内框宽度', '外沿成品尺寸', '内沿成品尺寸', '自定义',];
    } else if (['弧形'].includes(plan3)) {
      widthExplain = ['玻璃内框宽度', '外沿成品尺寸', '内沿成品尺寸', '自定义',];
    } else if (['斜边型'].includes(plan3)) {
      widthExplain = ['玻璃内框宽度', '外沿成品尺寸', '内沿成品尺寸', '自定义',];
    }
  } else if (['窗帘盒挡板'].includes(plan1)) {
    if (plan2 === '顶装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '内框宽度', '左石膏线到右石膏线', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '内框宽度', '左（）到右（）', '飘窗内满墙宽', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型飘窗左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型飘窗左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20公分', '轨道成品尺寸', '自定义',];
      }
    } else if (plan2 === '侧装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '左（）到右（）', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗内满墙宽', '满墙尺寸', '内框宽度', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      }
    } else if (plan2 === '已安装') {
      if (['普通窗', '外开窗', '推拉窗', '落地窗'].includes(plan3)) {
        widthExplain = ['满墙尺寸', '满窗尺寸', '窗框两边已各加20厘米', '左（）到右（）', '轨道成品尺寸', '自定义',];
      } else if (['一字型飘窗'].includes(plan3)) {
        widthExplain = ['飘窗内满墙宽', '满墙尺寸', '内框宽度', '左（）到右（）', '窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型飘窗'].includes(plan3)) {
        widthExplain = ['U型飘窗满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型飘窗', '右L型飘窗'].includes(plan3)) {
        widthExplain = ['L型飘窗满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗框两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['U型窗'].includes(plan3)) {
        widthExplain = ['U型阳台总长', 'U型满墙尺寸', 'U型窗内框尺寸', 'U型左（）到右（）', 'U型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['左L型窗', '右L型窗'].includes(plan3)) {
        widthExplain = ['L型阳台总长', 'L型满墙尺寸', 'L型窗内框尺寸', 'L型左（）到右（）', 'L型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      } else if (['异型窗'].includes(plan3)) {
        widthExplain = ['异型窗满墙尺寸', '异型窗框内尺寸', '异型窗左（）到右（）', '异型窗两边已各加20厘米', '轨道成品尺寸', '自定义',];
      }
    }
  } else {
    widthExplain = ['自定义'];
  }
  if (!widthExplain[0]) {
    widthExplain = ['自定义'];
  }
  return widthExplain;
};
export const sizeHeight2 = (plan1, plan2, plan3) => {
  plan2 = plan2.split('|')[0]
  let heightExplain = [];
  if (['直轨', '弯轨'].includes(plan1)) {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '盒顶到大飘窗台面', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '吊顶到大飘窗台面', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '房顶到大飘窗台面', '窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到窗下（）厘米', '挂钩下沿到大飘窗台面', '挂钩下沿到客户指定位置', '盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '盒顶下沿到大飘窗台面', '挂钩成品尺寸', '自定义',];
    }
  } else if (['超薄直轨', '超薄弯轨'].includes(plan1)) {
    if (plan2 === '顶装') {
      heightExplain = ['窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '窗框顶到大飘窗台面', '飘窗顶到飘窗台面', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '吊顶到大飘窗台面', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '房顶到大飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到窗下（）厘米', '挂钩下沿到大飘窗台面', '挂钩下沿到客户指定位置', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '内嵌式轨道') {
    if (plan2 === '顶装') {
      heightExplain = ['窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '窗框顶到大飘窗台面', '飘窗顶到飘窗台面', '飘窗顶到窗下（）厘米', '槽顶到地面', '槽顶到台面', '槽顶到窗下（）厘米', '槽顶到大飘窗台面', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '吊顶到大飘窗台面', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '房顶到大飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到客户指定位置', '挂钩下沿到窗下（）厘米', '挂钩下沿到大飘窗台面', '槽顶到地面', '槽顶到台面', '槽顶到窗下（）厘米', '槽顶到大飘窗台面', '挂钩成品尺寸', '自定义',];
    }
  } else if (['罗马杆', '宜家罗马杆'].includes(plan1)) {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '打孔成品尺寸', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线下到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '打孔成品尺寸', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '两头装') {
      heightExplain = ['房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '石膏线下到地面', '石膏线下到台面', '石膏线下到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '打孔成品尺寸', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['罗马杆杆上沿到地面', '罗马杆杆上沿到台面', '罗马杆杆上沿到窗下（）厘米', '罗马杆吊环下沿到地面', '罗马杆吊环下沿到台面', '罗马杆吊环下沿到窗下（）厘米', '打孔成品尺寸', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '梦幻帘') {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['轨道下沿到地面', '轨道下沿到台面', '轨道下沿到客户指定位置', '轨道下沿到窗下（）厘米', '走珠下沿到地面', '走珠下沿到台面', '走珠下沿到客户指定位置', '走珠下沿到窗下（）厘米', '挂珠成品尺寸', '自定义',];
    }
  } else if (['成品帘', '百叶帘', '卷帘', '香格里拉帘', '柔纱帘', '斑马帘', '罗马帘', '木百叶', '蜂巢帘', '日夜帘',
    '垂直帘', '竹草帘', '风琴帘', '内开内倒帘', '哈纳斯帘', '麻草帘'
  ].includes(plan1)) {
    if (['内顶装', '内侧装', '内两头装', '免打孔'].includes(plan2)) {
      heightExplain = ['内框高度', '成品尺寸', '自定义',];
    } else if (plan2 === '外顶装') {
      heightExplain = ['盒顶到窗台面', '盒顶到窗下（）厘米', '房顶到窗台面', '房顶到窗下（）厘米', '吊顶到窗台面', '吊顶到窗下（）厘米', '成品尺寸', '自定义',];
    } else if (plan2 === '外两头装') {
      heightExplain = ['吊顶到窗台面', '吊顶到窗下（）厘米', '房顶到窗台面', '房顶到窗下（）厘米', '石膏线下到窗台面', '石膏线下到窗下（）厘米', '成品尺寸', '自定义',];
    } else if (plan2 === '外侧装') {
      heightExplain = ['石膏线下到窗台面', '石膏线下到窗下（）厘米', '房顶到窗台面', '房顶到窗下（）厘米', '吊顶到窗台面', '吊顶到窗下（）厘米', '窗户上已加10厘米到窗台面', '成品尺寸', '自定义',];
    }
  } else if (plan1 === '蛇形帘') {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '盒顶到大飘窗台面', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '吊顶到大飘窗台面', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '房顶到大飘窗台面', '窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['轨道下沿到地面', '轨道下沿到台面', '轨道下沿到窗下（）厘米', '轨道下沿到客户指定位置', '轨道下沿到大飘窗台面', '盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '盒顶到大飘窗台面', '挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到窗下（）厘米', '挂钩下沿到客户指定位置', '挂钩下沿到大飘窗台面', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '蜂巢天窗') {
    heightExplain = ['玻璃内框高度', '内框尺寸', '成品尺寸', '自定义',];
  } else if (['折叠门', 'PVC门帘', '壁虎帘'].includes(plan1)) {
    heightExplain = ['内框尺寸', '成品尺寸', '自定义',];
  } else if (plan1 === '磁控百叶') {
    if (plan2 === '玻璃内框') {
      heightExplain = ['玻璃内框高度', '外沿成品尺寸', '内沿成品尺寸', '成品尺寸', '自定义',];
    }
  } else if (['无类型(幔)', '无类型(熨烫)', '宜家轨道', '连体轨道'].includes(plan1)) {
    if (plan2 === '顶装') {
      heightExplain = ['盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到窗下（）厘米', '挂钩下沿到客户指定位置', '盒顶到地面', '盒顶到台面', '盒顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    }
  } else if (plan1 === '窗帘盒挡板') {
    if (plan2 === '顶装') {
      heightExplain = ['房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '窗框顶到地面', '窗框顶到台面', '窗框顶到窗下（）厘米', '飘窗顶到飘窗台面', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '侧装') {
      heightExplain = ['石膏线下到地面', '石膏线下到台面', '石膏线到窗下（）厘米', '吊顶到地面', '吊顶到台面', '吊顶到窗下（）厘米', '房顶到地面', '房顶到台面 ', '房顶到窗下（）厘米', '挂钩成品尺寸', '自定义',];
    } else if (plan2 === '已安装') {
      heightExplain = ['挂钩下沿到地面', '挂钩下沿到台面', '挂钩下沿到窗下（）厘米', '挂钩下沿到客户指定位置', '挂钩成品尺寸', '自定义',];
    }
  } else {
    heightExplain = ['自定义'];
  }
  if ((rodrailsTypes.includes(plan1) || standardsTypes.includes(plan1) || plan1 === '梦幻帘') && ['一字型飘窗', 'U型飘窗', '左L型飘窗', '右L型飘窗'].includes(plan3)) {
    heightExplain.push('飘窗垫高度说明');
  }
  return heightExplain;
}